export const FILTERS_BASE_CLASS = "location-search-filters";
export const SLIDER_BASE_CLASS = "location-search-slider";

export const LINEUPS_BASE_CLASS = "location-search-lineups";
export const LINEUP_BASE_CLASS = "location-search-lineup";

export const ITEMS_BASE_CLASS = "location-search-items";
export const ITEM_BASE_CLASS = "location-search-item";